import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { staffRoutes } from "@/staff/StaffRoutes";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Navigate to="/staff" replace />} />
          {staffRoutes}
          <Route path="*" element={<Navigate to="/staff" replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
